import { render, staticRenderFns } from "./RelatesSongs.vue?vue&type=template&id=e79441e2&scoped=true&"
import script from "./RelatesSongs.vue?vue&type=script&lang=js&"
export * from "./RelatesSongs.vue?vue&type=script&lang=js&"
import style0 from "./RelatesSongs.vue?vue&type=style&index=0&id=e79441e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79441e2",
  null
  
)

export default component.exports